import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CommonState } from '../+state/common.reducer';
import { loadConfiguration } from '../+state/common.actions';
import { getConfiguration } from '../+state/common.selectors';
import {createUid} from "@dcs-workspace/shared";

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  constructor(private store: Store<CommonState>) {}

  async init(): Promise<unknown> {
    if (location.hash.length > 0) {
      const token = location.hash.replace('#id_token=', '');

      sessionStorage.setItem('id_token', token);

      history.replaceState(
        {},
        document.title,
        window.location.href.split('#')[0]
      );
    }

    return new Promise((resolve) => {
      this.store
        .select(getConfiguration)
        .pipe(filter((config) => !!config))
        .subscribe(() => resolve(true));
      this.store.dispatch(loadConfiguration());
      this.store.dispatch(createUid());
    });
  }
}
